import { Job } from 'server/shared/models/job';
import { Customers } from 'server/shared/collections/customers';
import { differenceInSeconds } from 'date-fns';
import { getJobStart } from 'server/shared/helpers/getJobStart';
import { InviteeStatusEnum } from 'server/shared/models/jobInviteeStatusEnum';

export function inviteesHaveCancelCost(job: Job) {
  return job.invitees
    .filter((invitee) => invitee.status === InviteeStatusEnum.BOOKED)
    .some((invitee) => {
      const customerOfInvitee = Customers.findOne({
        _id: invitee.customer.id,
      });
      return (
        customerOfInvitee?.transferCancelCostPeriod &&
        customerOfInvitee.transferCancelCostPeriod >
          differenceInSeconds(getJobStart(job.shifts, job.date), new Date()) /
            3600 &&
        differenceInSeconds(getJobStart(job.shifts, job.date), new Date()) /
          3600 >
          0
      );
    });
}
